'use client';

import { Suspense, useEffect, useMemo, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import Link from 'next/link';

import { getSearchParams } from 'app/utility/helpers';

function ButtonLoadMoreInner({ currentPage = 1 }: { currentPage?: number }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const nextPageUrl = useMemo(() => {
    return `${pathname}?${getSearchParams(searchParams, [
      { name: 'page', value: `${currentPage + 1}` }
    ])}`;
  }, [pathname, searchParams, currentPage]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [currentPage]);

  return (
    <Link
      href={`${nextPageUrl}`}
      scroll={false}
      className="button-default min-h-10 border-brown-20 hover:border-brown flex gap-2 items-center"
      onClick={() => setIsLoading(true)}
    >
      <span className="-mb-0.5">Показать ещё</span>
      {isLoading && <span className="spinner w-3.5 h-3.5 border"></span>}
    </Link>
  );
}

export default function ButtonLoadMore(props: { currentPage?: number }) {
  return (
    <Suspense fallback={null}>
      <ButtonLoadMoreInner {...props} />
    </Suspense>
  );
}
